import { render, staticRenderFns } from "./ProjectChoiceOptions.vue?vue&type=template&id=69209848&scoped=true&"
import script from "./ProjectChoiceOptions.vue?vue&type=script&lang=js&"
export * from "./ProjectChoiceOptions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69209848",
  null
  
)

export default component.exports